require('../../../modules/es.array.map');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').map;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/map.js
// module id = 977
// module chunks = 0